var _rect, _path, _path2, _path3, _ellipse, _ellipse2, _ellipse3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLabDiagnosticsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 42,
    height: 42,
    rx: 9,
    fill: "url(#paint0_linear_19577_33209)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.2998H24.5",
    stroke: "#118076",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24.2998H26",
    stroke: "#118076",
    strokeWidth: 1.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4997 14.2998V20.2998L28.6747 26.6692C29.2057 27.3227 28.7407 28.2998 27.8986 28.2998H14.1005C13.2585 28.2998 12.7934 27.3227 13.3244 26.6692L18.4996 20.2998V14.2998",
    stroke: "#118076",
    strokeWidth: 1.7
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5,
    cy: 11.7998,
    rx: 0.5,
    ry: 0.5,
    fill: "#118076"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.5,
    cy: 9.7998,
    rx: 0.500001,
    ry: 0.5,
    fill: "#118076"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 12.2998,
    rx: 1,
    ry: 1,
    fill: "#118076"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_19577_33209",
    x1: 21,
    y1: 1,
    x2: 21,
    y2: 43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2F4F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabDiagnosticsIcon);
export default __webpack_public_path__ + "static/media/LabDiagnosticsIcon.fd3a5d4ff837b0c04a41465f43a3f9e5.svg";
export { ForwardRef as ReactComponent };